import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Message } from '@openng/optimus-ui/message';

@Component({
  template: `
    <p-message
      severity="error"
      class="block mt-1 text-sm"
      data-testid="accessUnavailable"
      i18n="@@error-access-unavailable"
      >The page you tried to access is unavailable or you do not have permission
      to view it. If you believe this is an error, please contact your
      administrator for assistance.</p-message
    >
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [Message],
})
export class AccessUnavailableComponent {}
